
import Vue from 'vue';
import { mapActions } from 'vuex';
import { ROUTER } from '@/router/constants';
import { DAILY_FREE_RUNNIT_TOKENS_BASE, DAILY_FREE_RUNNIT_TOKENS_CAP } from '@run-diffusion/shared';

/*
 * Help Center FAQ list. Deliberately not RunnitFaqs: that component lives under the
 * subscriptions plans table and several of its answers say "the table above", which is
 * false on /help. The copy here is the same body of answers re-pointed at the Manage My
 * Plan action on this page, which the parent owns (it routes freemium users to the
 * subscriptions page instead of opening the upsell dialog) — hence the manage-plan event.
 */
export default Vue.extend({
	name: 'HelpCenterFaqs',
	data () {
		return {
			ROUTER,
			DAILY_FREE_RUNNIT_TOKENS_CAP,
			DAILY_FREE_RUNNIT_TOKENS_BASE,
		};
	},
	methods: {
		...mapActions([
			'setUpsellDialog',
			'goToStripeSubscriptionPortal',
		]),
		onOpenPlanDetailDialog () {
			this.setUpsellDialog({
				runnitPlanDetailsData: {
					open: true,
				},
			});
		},
	},
});
